import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGithub, FaExternalLinkAlt, FaRobot, FaArrowRight } from 'react-icons/fa';
import { aiProjectsData } from '../data/aiProjects';
import './AIProjects.css';

const AIProjects = () => {
  const data = aiProjectsData;
  const navigate = useNavigate();

  return (
    <section id="ai-projects" className="ai-projects-section">
      <div className="section-heading fade-in-up">
        <div className="ai-section-badge">
          <FaRobot className="ai-badge-icon" />
          <span>AI / ML</span>
        </div>
        <h2>{data.heading}</h2>
        <p>{data.description}</p>
      </div>

      <div className="ai-projects-grid">
        {data.projects.map((project) => (
          <div key={project.id} className="ai-project-card fade-in-up">
            <div className={`ai-project-image ${project.coverIsDark ? 'ai-project-image--dark' : ''}`}>
              <img src={project.image} alt={project.title} />
              <div className="ai-project-overlay">
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="GitHub"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FaGithub />
                  </a>
                )}
                {project.demo && (
                  <a
                    href={project.demo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="Demo"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FaExternalLinkAlt />
                  </a>
                )}
              </div>
            </div>

            <div className="ai-project-content">
              <h3 className="ai-project-title" onClick={() => navigate(`/ai-projects/${project.id}`)}>{project.title}</h3>
              <p className="ai-project-tagline">{project.tagline}</p>

              <div className="ai-project-technologies">
                {project.technologies.slice(0, 5).map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
                {project.technologies.length > 5 && (
                  <span className="tech-tag tech-tag-more">+{project.technologies.length - 5} more</span>
                )}
              </div>

              <div className="ai-card-actions">
                <button
                  className="ai-view-details-btn"
                  onClick={() => navigate(`/ai-projects/${project.id}`)}
                >
                  View Details
                  <FaArrowRight className="btn-arrow" />
                </button>
                {project.demo && (
                  <a
                    href={project.demo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ai-live-demo-btn"
                  >
                    <FaExternalLinkAlt /> Live Demo
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AIProjects;
